let baseURL = 'https://storecareersapp.com'

export {baseURL}